var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loader",style:(_vm.skeletonStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }